// 首页
import request from '@/utils/request'

// 设备基本信息
export function findDeviceInfo(params) {
  return request({
    url: '/v3/report/findDeviceInfo',
    method: 'post',
    data: params
  })
}
// 提交配置--dcdc
export function setDMTCfg(params) {
  return request({
    url: '/v3/device/mqtt/setDMTCfg',
    method: 'post',
    data: params
  })
}
// 提交配置--bidirectional（双向逆变器）
export function setIvtCfg(params) {
  return request({
    url: '/v3/device/mqtt/setIvtCfg',
    method: 'post',
    data: params
  })
}
// 提交配置--inverterDetailNew（单向逆变器）
export function setCBBCfg(params) {
  return request({
    url: '/v3/device/mqtt/setCBBCfg',
    method: 'post',
    data: params
  })
}
// 提交配置--acChargeDetail（AC充电器）
export function setTCCfg(params) {
  return request({
    url: '/v3/device/mqtt/setTCCfg',
    method: 'post',
    data: params
  })
}
// 获取配置--dcdc
export function getDMTCfg(params) {
  return request({
    url: '/v3/device/mqtt/getDMTCfg',
    method: 'get',
    params: params
  })
}
// 获取配置--bidirectional（双向逆变器）
export function getIvtCfg(params) {
  return request({
    url: '/v3/device/mqtt/getIvtCfg',
    method: 'get',
    params: params
  })
}
// 获取配置--inverterDetailNew（单向逆变器）
export function getCBBCfg(params) {
  return request({
    url: '/v3/device/mqtt/getCBBCfg',
    method: 'get',
    params: params
  })
}
// 获取配置--acChargeDetail（AC充电器）
export function getTCCfg(params) {
  return request({
    url: '/v3/device/mqtt/getTCCfg',
    method: 'get',
    params: params
  })
}
